import * as React from "react";
import { AreaChart as AreaChartRe, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList, ResponsiveContainer } from 'recharts';
import ChartTooltip from "./ChartTooltip";
import getColor from "./colors";
import { formatNumber } from "../../helpers/UtilityHelper";
import ChartEmpty from "./ChartEmpty";

// Value label on each data point — opt-in via chartOptions.showLabels.
const valueLabelStyle = { fontSize: 10, fontWeight: 600, fill: '#374151' };
const formatValue = (v) => (v === 0 || v ? formatNumber(v) : '');

export default function AreaChart({ width = "100%", data, height = 350, chartOptions }) {
    if (!data || data.length === 0) return <ChartEmpty height={height} />

    return (
        <ResponsiveContainer width={width} height={height}>
            <AreaChartRe
                data={data}
                margin={{ top: 24, right: 16, bottom: 0, left: 0 }}
            >
                <CartesianGrid strokeDasharray="5 5" stroke="#dee2e6" />
                <XAxis dataKey={chartOptions?.xaxis} fontSize="11px" fontWeight="500" />
                <YAxis fontSize="11px" fontWeight="500" />
                <Tooltip content={<ChartTooltip />} />
                <Legend verticalAlign="top" align="right" iconSize="10px" iconType="circle" wrapperStyle={{ fontSize: 11, fontWeight: 500 }} />
                {
                    chartOptions?.data.map((row, i) => (
                        <Area
                            key={i}
                            dataKey={row.dataKey}
                            type="monotone"
                            fill={row.fill || getColor(row.colorIndex || i)}
                            stroke={row.fill || getColor(row.colorIndex || i)}
                            name={row.label}
                            unit={row.unit || ""}
                            animationEasing="ease-in-out"
                            animationDuration={1000}
                        >
                            {chartOptions?.showLabels && (
                                <LabelList dataKey={row.dataKey} position="top" offset={10} style={valueLabelStyle} formatter={formatValue} />
                            )}
                        </Area>
                    ))
                }
            </AreaChartRe>
        </ResponsiveContainer>
    )
}